import SystemModal from "../Common/SystemModal";
import { useState, useEffect } from "react";
import toast, { Toaster } from "react-hot-toast";
import Loader from "../Common/Loader";
import Select from "react-select";
import ajaxStations from "../../util/remote/ajaxStations";
import ajaxShiftTemplate from "../../util/remote/ajaxShiftTemplate";

const UpdateShiftTemplateModal = (props) => {
  const [loading, setLoading] = useState(false);

  const [stationID, setStationID] = useState("");
  const [shiftName, setShiftName] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");

  const [stations_list, setStationsList] = useState([]);
  // PRE-FILL DATA WHEN MODAL OPENS
  useEffect(() => {
    if (!props.data) return;

    const d = props.data;

    setStationID(d.station_id || "");
    setShiftName(d.shift_name || "");
    setStartTime(d.start_time ? d.start_time.substring(0, 5) : "");
    setEndTime(d.end_time ? d.end_time.substring(0, 5) : "");
  }, [props.data.id]);

  // Load Stations
  const fetchStations = async () => {
    setLoading(true);

    const response = await ajaxStations.liststations_mini_data();
    if (response.status === "OK") {
      const list =
        Array.isArray(response.details) &&
        response.details.map((st) => ({
          value: st.id,
          label: st.station_name,
        }));
      setStationsList(list);
    } else {
      toast.error(response.message);
    }

    setLoading(false);
  };

  useEffect(() => {
    fetchStations();
  }, []);

  // VALIDATION
  const allRowsFilled = () => shiftName && startTime && endTime;

  // HANDLE UPDATE
  const handleUpdate = async (e, closeModal) => {
    e.preventDefault();

    if (!allRowsFilled()) {
      toast.error("Please fill in all fields");
      return;
    }

    const payload = {
      id: props.data.id,
      station_id: stationID,
      shift_name: shiftName,
      start_time: startTime, // HH:MM
      end_time: endTime, // HH:MM
    };

    setLoading(true);
    const response = await ajaxShiftTemplate.update_shit_templates(payload);
    setLoading(false);

    if (response.status === "OK") {
      toast.success(response.message);
      props.func();
      setTimeout(() => closeModal(), 800);
    } else {
      toast.error(response.message);
    }
  };

  // FOOTER BUTTONS
  const RenderFooter = (controls) => (
    <>
      <button className="btn btn-secondary" onClick={controls.close}>
        Close
      </button>
      <button
        className="btn btn-primary"
        disabled={loading || !allRowsFilled()}
        onClick={(e) => handleUpdate(e, controls.close)}
      >
        {loading ? <Loader /> : "Update Shift"}
      </button>
    </>
  );

  return (
    <SystemModal title="Update Shift Template" size="md" footer={RenderFooter}>
      <Toaster />

      {loading && <Loader />}

      <div className="container-fluid">
        <div className="card custom-card" style={{ borderRadius: "12px" }}>
          <div className="card-body">
            <h6 className="card-title mb-3">Edit Shift Details</h6>

            <form>
              <div className="mb-3">
                <label>Station</label>
                <Select
                  options={stations_list}
                  value={stations_list.find(
                    (s) => s.value.toString() === stationID?.toString()
                  )}
                  isDisabled={true}
                />
              </div>

              <div className="mb-3">
                <label>Shift Name *</label>
                <input
                  type="text"
                  value={shiftName}
                  onChange={(e) => setShiftName(e.target.value)}
                  className="form-control"
                  placeholder="Enter shift name"
                />
              </div>

              <div className="row">
                <div className="col-md-6 mb-3">
                  <label>Start Time *</label>
                  <input
                    type="time"
                    value={startTime}
                    onChange={(e) => setStartTime(e.target.value)}
                    className="form-control"
                  />
                </div>

                <div className="col-md-6 mb-3">
                  <label>End Time *</label>
                  <input
                    type="time"
                    value={endTime}
                    onChange={(e) => setEndTime(e.target.value)}
                    className="form-control"
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </SystemModal>
  );
};

export default UpdateShiftTemplateModal;
